import {renderPortraitCredit} from "./portrait-rendering.js";

// The visible inspector adds at most two explicit priorities to the existing
// bounded portrait store. Closing it must not keep offscreen acquisitions alive.
export function inspectorPortraitPeople(graph, state, visible) {
  if (!visible) return [];
  if (state.selectedNode && graph.hasNode(state.selectedNode)) return [graph.getNodeAttributes(state.selectedNode)];
  if (!state.selectedEdge || !graph.hasEdge(state.selectedEdge)) return [];
  return graph.extremities(state.selectedEdge).filter(id=>graph.hasNode(id)).map(id=>graph.getNodeAttributes(id));
}

export function renderRelationPortraits(container, people, getPortrait, personHref) {
  const pairs=people.slice(0,2).map(person=>({person,record:getPortrait(person.wikidataId)}));
  container.hidden=!pairs.some(({record})=>record?.status==="ready");
  for (const [index,{person,record}] of pairs.entries()) {
    let slot=container.children[index];
    if (!slot) {slot=document.createElement("div");slot.className="relation-person";container.append(slot);}
    const ready=record?.status==="ready";
    // Preserve focused credits and the sibling portrait during asynchronous
    // updates, rather than replacing the entire relation panel.
    const signature=JSON.stringify([person.id,person.name,ready?{...record,image:undefined}:null]);
    if (slot.dataset.signature===signature) continue;
    slot.dataset.signature=signature;slot.replaceChildren();
    const link=document.createElement("a");link.className="person-connection relation-person-link";
    link.href=personHref(person.id);link.dataset.person=person.id;
    const name=document.createElement("span");name.textContent=person.name || person.label;link.append(name);
    if (ready) {
      renderPortraitCredit(slot,record,{compact:true});
      const figure=slot.querySelector("figure"),image=figure.querySelector("img");
      image.alt="Portrait de "+(person.name || person.label);
      link.prepend(image);figure.prepend(link);
    } else slot.append(link); // No invented face or broken-image placeholder.
  }
  while (container.children.length>pairs.length) container.lastElementChild.remove();
}
